import templateUrl from './payroll-dashboard.component.html'

export const PayrollDashboardComponent = {
    templateUrl,
    controller: PayrollDashboardController,
    controllerAs: "vm",
    bindings: {
        identity: "<"
    }
}

function PayrollDashboardController($q, utilityService, payrollDashboardService, payrollService) {
    'ngInject'
    const vm = this;

    // TODO: Extract into generic dashboard, like the main dashboard page.
    vm.$onInit = $onInit
    vm.$onChanges = $onChanges;
    vm.filters = {};
    vm.rotationFilters = {};
    vm.payrollCorporations;
    vm.payrollRotations;

    vm.loadPayrollDetails = loadPayrollDetails;
    vm.hidePayroll = hidePayroll;
    vm.filterPayrolls = filterPayrolls;
    vm.filterRotations = filterRotations;
    vm.filterPayrollCorporations = filterPayrollCorporations;
    vm.joinDivisionCountries = joinDivisionCountries;

    function $onInit() {
        utilityService.showLoading();
        $q.all([
            payrollDashboardService.retrievePayrollCorporations()
                .then(function (payrollCorporations) {
                    vm.payrollCorporations = payrollCorporations;
                }),
            payrollDashboardService.retrievePayrollRotations()
                .then(function (payrollRotations) {
                    vm.payrollRotations = payrollRotations;
                })
        ])
            .catch(function () {
                alert("initial load failed");
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function $onChanges() {
        vm.employeeID = vm.identity.EmployeeID;
        vm.isSiteAdmin = vm.identity.IsSiteAdmin;
    }

    function loadPayrollDetails(payrollListItem) {
        if (!payrollListItem.expanded) {
            retrievePayrollData(payrollListItem)
                .then(function (payrollData) {
                    payrollListItem.data = payrollData;
                });
        }
        payrollListItem.expanded = !payrollListItem.expanded;
    }

    function retrievePayrollData(payrollListItem) {
        if (payrollListItem.data) {
            return $q.when(payrollListItem.data);
        }
        return payrollService.retrievePayroll(payrollListItem.PayrollID)
            .then(function (payroll) {
                const getUniqueEmployees = function (payrollEntries) {
                    return Object.keys(payrollEntries.reduce(function (o, v, i, a) {
                        if (!o[v.EmployeeId]) {
                            o[v.EmployeeId] = true;
                        }

                        return o;
                    }, {}))
                };
                const getManHoursWorked = function (payrollEntries) {
                    return payrollEntries.reduce(function (sum, payrollEntry) {
                        return sum + payrollEntry.PayDates.reduce(function (sum, payDate) {
                            return sum + (payDate.EmployeeHoursWorked || 0);
                        }, 0);
                    }, 0);
                }
                payroll.employeeCount = getUniqueEmployees(payroll.OwnerPayrollEntries).length
                    + getUniqueEmployees(payroll.OfficeAdminPayrollEntries).length
                    + getUniqueEmployees(payroll.SalesPayrollEntries).length
                    + getUniqueEmployees(payroll.ContractorPayrollEntries).length;
                payroll.totalHoursWorked = getManHoursWorked(payroll.OwnerPayrollEntries)
                    + getManHoursWorked(payroll.OfficeAdminPayrollEntries)
                    + getManHoursWorked(payroll.SalesPayrollEntries)
                    + getManHoursWorked(payroll.ContractorPayrollEntries);
                return payroll;
            });
    }

    function filterPayrolls(payroll) {
        return (payroll.ClientName || "").toLowerCase().indexOf((vm.filters.ClientName || "").toLowerCase()) >= 0
            && (payroll.Owner || "").toLowerCase().indexOf((vm.filters.Owner || "").toLowerCase()) >= 0
            && (!vm.rotationFilters.CheckDate || vm.rotationFilters.CheckDate >= payroll.StartDate
                && vm.rotationFilters.CheckDate <= payroll.EndDate)
            && (vm.filters.Locked === undefined || payroll.Locked === undefined
                || payroll.Locked === vm.filters.Locked);
    }

    function filterRotations(rotation) {
        return rotation.Payrolls.filter(filterPayrolls).length > 0;
    }

    function filterPayrollCorporations(corporation) {
        return corporation.DivisionCountries.filter(function (divisionCountry) {
            return divisionCountry.Payrolls.filter(filterPayrolls).length > 0;
        }).length > 0;
    }

    function joinDivisionCountries(separator, divisionCountries) {
        return divisionCountries.map(function (divisionCountry) {
            return divisionCountry.DivisionName + " (" + divisionCountry.CountryName + ")";
        }).join(separator);
    }

    function hidePayroll(payroll) {
        utilityService.showLoading();
        payrollService.savePayrollVisible(payroll.PayrollID, !!payroll.hidden)
            .catch(() => { })
            .then(function () {
                payroll.hidden = !payroll.hidden;
            })
            .then(utilityService.hideLoading);
    }
}
